<script>
  import classNames from 'classnames';
  import { getContext, onMount } from 'svelte';
  import { writable } from 'svelte/store';
  import { slide } from 'svelte/transition';
  export let open = false;

  const ctx = getContext('ctx') ?? {};
  // single selection
  const self = {};
  const selected = ctx.selected ?? writable();
  const _open = open;
  open = false;
  onMount(() => {
    if (_open) $selected = self;
    // this will trigger unsubscribe on destroy
    return selected.subscribe((x) => (open = x === self));
  });
  const handleToggle = () => selected.set(open ? {} : self);
  let indicatorClass;
  $: indicatorClass = classNames(
    'text-xs',
    open ? 'text-gray-700 rotate-90' : 'text-gray-400',
  );
  const buttonClass =
    'font-medium text-neutral-800 flex items-center justify-center gap-1.5 text-left';
</script>

<h2 class="group">
  <button
    on:click|preventDefault={handleToggle}
    type="button"
    aria-expanded={open}
    class={buttonClass}
  >
    <span class={indicatorClass}>&#x25b6</span>
    <slot name="header" />
  </button>
</h2>
{#if open}
  <div transition:slide class="pl-4 text-sm">
    <slot />
  </div>
{/if}
